import request from '@/utils/request';

export function getSaaSproviders() {
  return request({
    url: '/ajax/saas/providers',
    method: 'get'
  });
}

export function getAppDetailInfo(eid, appKeyID, appVersion) {
  return request({
    url:
      '/ajax/enterprises/' +
      eid +
      '/apps/' +
      appKeyID +
      '?version=' +
      appVersion,
    method: 'get'
  });
}

export function createOrder(data) {
  return request({
    url: `/order-server/customer/orders`,
    method: 'post',
    data
  });
}



// WEBPACK FOOTER //
// ./src/api/payment.js